import React from 'react'

import iconLocation from "./../../images/icons/location.svg";
import iconClock from "./../../images/icons/clock.svg";
import iconBus from "./../../images/icons/Bus.svg";
import iconSmartphone from "./../../images/icons/Smartphone.svg";

const DescriptionDayOfOpenDoors = ({ resources, title }) => {
    return (
        <>
            <div className="mt-5 mb-2">
                <p dangerouslySetInnerHTML={{ __html: resources?.DayOfOpenDoor_HomeDescription1 }}></p>
            </div>

            {/* Important Information Section */}
            <div className="mt-5 mb-5">
                <p>
                    <span className="subtitle">Wichtige Hinweise:</span>
                </p>
                <div className="row mb-4">
                    <div className="col-auto text-center" style={{ minWidth: "80px" }}>
                        <img src={iconLocation} alt="Location" style={{ width: '31px', height: '40px' }} />
                    </div>
                    <div className="col">
                        <p className="mb-0">
                            Startpunkt: Eingang Tiefgarage Neubau Kinderspital/Frauenklinik (Haus 36).
                            Zugang über die Spitalstrasse, neben dem XUND via Unterhofweg. Bitte folgen Sie
                            den Wegweisern.
                        </p>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-auto text-center" style={{ minWidth: "80px" }}>
                        <img src={iconClock} alt="Clock" style={{ width: '40px', height: '40px' }} />
                    </div>
                    <div className="col">
                        <p className="mb-0">
                            Bitte 10 Minuten vor Start pünktlich erscheinen. Vor dem Rundgang gibt es keine Warte-
                            oder Aufenthaltsmöglichkeiten. Wir bitten Sie daher, nicht früher als 15 Minuten vor
                            Ihrem Termin zu erscheinen.
                        </p>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-auto text-center" style={{ minWidth: "80px" }}>
                        <img src={iconBus} alt="Bus" style={{ width: '57px', height: '30px' }} />
                    </div>
                    <div className="col">
                        <p className="mb-0">
                            Anreise: Es stehen vor Ort keine Parkplätze zur Verfügung. Wir empfehlen eine Anreise
                            mit den öffentlichen Verkehrsmitteln. (siehe <a href="https://www.luks.ch/entdecken" target="_blank" rel="noopener noreferrer">www.luks.ch/entdecken</a>).
                        </p>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-auto text-center" style={{ minWidth: "80px" }}>
                        <img src={iconSmartphone} alt="Smartphone" style={{ width: '25px', height: '40px' }} />
                    </div>
                    <div className="col">
                        <p className="mb-0">
                            Das Ticket bitte digital oder ausgedruckt mitbringen.
                            <br />
                            Eine Teilnahme am Anlass ist nur mit gültiger Anmeldung für einen Zeitslot möglich.
                        </p>
                    </div>
                </div>
            </div>

            <div className="mt-5 mb-2">
                <p dangerouslySetInnerHTML={{ __html: resources?.DayOfOpenDoor_HomeDescription2 }}></p>
            </div>
        </>
    )
}

export default DescriptionDayOfOpenDoors